/**
 * List Schema of PanelUser
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'

/* TODO: review generated schema */
export class ListPanelUserSchema extends Schema {
  readonly name = 'ListPanelUser'

  readonly fieldSet: FieldSet<PanelUser> = {
    id: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.idPanelUserPk,
      },
    }),
    document: (): FieldComponent => ({
      is: Component.Render,
    }),
    corporateName: (): FieldComponent => ({
      is: Component.Render,
    }),
    contactName: (): FieldComponent => ({
      is: Component.Render,
    }),
    telephone: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.telephone,
      },
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
    dueDate: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dueDate),
      },
    }),
    userType: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.userType?.$tag,
      },
    }),
    createdByAdm: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.createdBy,
      },
    }),
  }
}
